@if (policiesLabels) {
  <tabs [tabLabels]="policiesLabels" (tabSelected)="setPolicy($event)">
    @for (tab of policiesLabels; track tab) {
      <div *templateRef>
        @if (tab === activeTab) {
          <ng-template [ngTemplateOutlet]="tabContent"></ng-template>
        }
      </div>
    }
  </tabs>
}

<!-- No Tabs  -->
@if (!activeTabs) {
  <section>
    <ng-template [ngTemplateOutlet]="tabContent"></ng-template>
  </section>
}

<ng-template #tabContent>
  <section class="policies__card__content">
    <section class="polcies__card__section">
      <div class="policies__card__attributes">
        <div tabindex="0" class="policies__card__section__header">
          <h6 class="t-bold" zip-test-id="plan-name">
            {{ activePolicy?.external_plan_name }}
            @if (policyStatus) {
              <status
                [config]="{
                  hideBackground: config.hideStatusBackground,
                  label: policyStatus?.label,
                }"
                [status]="policyStatus?.statusType"
              >
              </status>
            }
          </h6>
        </div>

        @for (attribute of config?.attributes?.attributes; track attribute) {
          @switch (attribute.context) {
            @case ('member') {
              @if (member) {
                <model-attribute
                  zip-test-id="member-attribute"
                  [context]="member"
                  [config]="attribute"
                >
                </model-attribute>
              }
            }
            @case ('group') {
              @if (policyGroup) {
                <model-attribute
                  zip-test-id="group-attribute"
                  [context]="policyGroup"
                  [config]="attribute"
                >
                </model-attribute>
              }
            }
            @default {
              <model-attribute
                zip-test-id="default-attribute"
                [context]="activePolicy"
                [config]="attribute"
              >
              </model-attribute>
            }
          }
        }
      </div>
    </section>

    @if (config?.costs) {
      <section zip-test-id="cost-section" class="policies__card__section">
        <div>
          <div class="policies__card__section__header">
            <h5 tabindex="0" class="t-bold" zip-test-id="cost-header">
              {{ costs.header }}
            </h5>
          </div>
          <progress-bar-grid [data]="progressBarsData"></progress-bar-grid>
        </div>
      </section>
    }
  </section>
</ng-template>
